"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypes = void 0;
exports.escapeDirectiveContent = escapeDirectiveContent;
exports.quoteDirectiveAttribute = quoteDirectiveAttribute;
var NodeTypes;
(function (NodeTypes) {
    NodeTypes["TextDirective"] = "textDirective";
    NodeTypes["LeafDirective"] = "leafDirective";
    NodeTypes["ContainerDirective"] = "containerDirective";
    NodeTypes["AllDirectives"] = "__all";
})(NodeTypes || (exports.NodeTypes = NodeTypes = {}));
function escapeDirectiveContent(value) {
    return value.replace(/([\\[\]])/g, '\\$1');
}
function quoteDirectiveAttribute(value) {
    return value.includes('"') ? `'${value}'` : `"${value}"`;
}
//# sourceMappingURL=MarkdownDirectiveDefinition.js.map